module.exports = __webpack_public_path__ + "img/qiyejieshao_bg.84d5d7f3.png";